<template>
  <el-tabs type="border-card" class="card-tab" @tab-click="tabClick">
    <el-tab-pane label="全部人员">
      <filter-param v-if="page==1" :webId="webId" :postId="0" :educationList="educationList" :starLevelList="starLevelList" :channelList="channelList" @filterParam="getParam" ref="fp1"></filter-param>
    </el-tab-pane>
    <el-tab-pane label="筛选长促" v-if="userIsPLUS">
      <filter-param v-if="page==2" :webId="webId" :postId="1" :educationList="educationList" :starLevelList="starLevelList" :channelList="channelList" @filterParam="getParam" ref="fp2"></filter-param>
    </el-tab-pane>
    <el-tab-pane label="筛选短促" v-if="userIsPLUS">
      <filter-param v-if="page==3" :webId="webId" :postId="2" :educationList="educationList" :starLevelList="starLevelList" :channelList="channelList" @filterParam="getParam" ref="fp3"></filter-param>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import FilterParam from 'components/filterParam'
import FilterTag from 'components/filterTag'
export default {
  components: {
    FilterParam,
    FilterTag
  },
  data() {
    return {
      educationList: [],
      starLevelList: [],
      channelList: [],
      provinceList: [],
      cityList: [],
      areaList: [],  
      loading: false,
      userIsPLUS:true,
      page:1
    }
  },
  props: ['webId'],
  mounted () {
    this.userIsPLUS = Boolean(sessionStorage.getItem('user'))
    this.loading = true

    // 学历
    this.$http({
      method: 'POST',
      url: '/rest/salesman/getEducation',
    }).then(res => {
      this.educationList = res.data
    }).catch(err => {
      let errMsg;
      if(err.response.message){
        errMsg = err.response.message
      }else{
        errMsg = '查询失败，请稍后重试'
      }
      this.$notify({
        title: '失败',
        message: errMsg,
        type: 'error'
      })
    })
    if(this.userIsPLUS){
      // 星级
      this.$http({
        method: 'POST',
        url: '/rest/salesman/getStarLevel',
      }).then(res => {
        this.starLevelList = res.data
      }).catch(err => {
        let errMsg;
        if(err.response.message){
          errMsg = err.response.message
        }else{
          errMsg = '查询失败，请稍后重试'
        }
        this.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        })
      })

      // 服务渠道
      this.$http({
        method: 'POST',
        url: '/rest/salesman/getChannel',
      }).then(res => {
        this.channelList = res.data
        this.loading = false
      }).catch(err => {
        let errMsg;
        if(err.response.message){
          errMsg = err.response.message
        }else{
          errMsg = '查询失败，请稍后重试'
        }
        this.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        })
      })
    }
  },
  methods: {
    tabClick (tab) {
      if (tab.label === '全部人员' && this.page != 1) {
        this.page = 1;
        setTimeout(()=>{
          //好像是可以在FilterParam中赋值pageNo和size
          this.$refs['fp1'].resetForm('paramForm')
          let x = this.$refs['fp1'].paramForm
          x.pageNo = 1;
          x.pageSize = 48;
          this.$emit('filterParam',x)
        },10)
      } else if (tab.label === '筛选长促' && this.page != 2) {
        this.page = 2;
        setTimeout(()=>{
          this.$refs['fp2'].resetForm('paramForm')
          let x = this.$refs['fp2'].paramForm
          x.pageNo = 1;
          x.pageSize = 48;
          this.$emit('filterParam',this.$refs['fp2'].paramForm)
        },10)
      } else if (tab.label === '筛选短促' && this.page != 3) {
        this.page = 3;
        setTimeout(()=>{
          this.$refs['fp3'].resetForm('paramForm')
          let x = this.$refs['fp3'].paramForm
          x.pageNo = 1;
          x.pageSize = 48;
          this.$emit('filterParam',this.$refs['fp3'].paramForm)
        },10)
      }
    },
    getParam (data) {
      data.pageNo = 1;
      data.pageSize = 48;
      this.$emit('filterParam',data)
    },
  }
}
</script>

<style lang="scss" scoped>
.reset-btn{
  margin-right: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/filterTab.vue